import { Box, Paper } from "@mui/material";
import { AgGridReact } from "ag-grid-react";
import { CenteredLazyLoading } from "../../../../../../controls/LazyLoading";
import { useDataEntryContext } from "../../../context/reducer.provider";
import { useTheme } from "@mui/material/styles";
import { eafDETablesStyles } from "../styles/eafDETablesStyles";
import { useTableData } from "./hooks/useSlagTableData";
import { defaultColDef, defaultGridOptions } from "@/setup/ag-grid/mesf-theme";

export const TableSlag = () => {
  const theme = useTheme();
  const styles = eafDETablesStyles(theme);

  const {
    state: { deProcess },
  } = useDataEntryContext();

  const { columns } = useTableData();

  return (
    <Paper>
      <Box padding={1} sx={styles.readOnlyAgGridBox}>
        <AgGridReact
          rowData={deProcess?.slags}
          columnDefs={columns}
          defaultColDef={{ ...defaultColDef, sortable: false }}
          loadingOverlayComponent={CenteredLazyLoading}
          {...defaultGridOptions}
        />
      </Box>
    </Paper>
  );
};
